
angular.module('mtic')
.directive('mtic', function (EventManager, $log, PlatformService) {
	return {
    templateUrl: 'template.html',
    restrict: 'E',
		scope: {
      isLive: '='
    },
		link: function(scope) {
      var eventManager = new EventManager('mtic', scope);
      var url = location.href;
      scope.isLive = url.indexOf('mathematic.lu') > -1 || url.indexOf('mathematic.org') > -1;

      if(PlatformService.isAndroid){
        // Android soft-keyboard fix -> https://stackoverflow.com/a/42817175
        // This forces the viewport meta to explicitly set viewport width and height, whereas hardcoding in HTML
        // doesn't work because the device-width and device-height change when Android's soft keyboard is opened.
        let viewport = document.querySelector("meta[name=viewport]");
        viewport.setAttribute("content", "height=" + window.outerHeight + ", width=" + window.outerWidth + ", initial-scale=1.0");
        // Need to force viewport size on orientation change
        window.addEventListener("orientationchange", (event)=>{
          window.setTimeout(()=>{
            let viewport = document.querySelector("meta[name=viewport]");
            viewport.setAttribute("content", "height=" + window.outerHeight + ", width=" + window.outerWidth + ", initial-scale=1.0");
          }, 300);
        }, true);
      }

    }
	}
});
